<template>
  <div id="app" :class="{ mobile: isMobile }">
    <router-view
      @changeMenuVisibility="handleMenuVisibilityChange"
      @changeMenuState="handleMenuStateChange"
      @changeMobileScrollText="handleMobileScrollTextChange"
    />
    <MainMenu
      v-if="showMenu"
      :transparentMode="transparentMode"
      :text="home.menu_blurb"
      :triggerOpen="openMenu"
      :isMobile="isMobile"
      :mobileScrollText="mobileScrollText"
      @isOpen="onMenuIsOpen"
    />
    <CookieConsent />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { generateMetaTags } from '@/util.js'
import MainMenu from '@/components/MainMenu'
import CookieConsent from '@/components/CookieConsent'

export default {
  name: 'App',

  metaInfo () {
    return {
      title: 'Experimenting, Experiencing, Reflecting',
      titleTemplate: 'EER | %s',
      meta: generateMetaTags('Experimenting, Experiencing, Reflecting', this.pageDescription, this.pageImage)
    }
  },

  components: {
    MainMenu,
    CookieConsent
  },

  computed: {
    ...mapState(['home', 'isMobile']),

    transparentMode () {
      return this.$route.path !== '/'
    },

    pageDescription () {
      return this.home ? this.home.menu_blurb : ''
    },

    pageImage () {
      return null
    }
  },

  data () {
    return {
      showMenu: true,
      openMenu: false,
      mobileScrollText: null,
      test: 'werd'
    }
  },

  created () {
    this.$store.dispatch('checkIsMobile')
  },

  mounted () {
    this.$store.dispatch('getHome')

    window.addEventListener('resize', this.updateHeight)
    this.updateHeight()
  },

  methods: {
    updateHeight() {
      document.documentElement.style.setProperty(
        '--app-height',
        window.innerHeight + 'px',
      )
    },

    handleMenuVisibilityChange (visible) {
      this.showMenu = visible
    },

    handleMenuStateChange (open) {
      setTimeout(() => {
        this.openMenu = open
      }, 1000)
    },

    handleMobileScrollTextChange (text) {
      this.mobileScrollText = text
    },

    onMenuIsOpen (open) {
      this.$store.commit('SET_MENUOPEN', open)
    }
  }
}
</script>
